import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
      key="/business/products/ar-virtual-accessories"
      exact
      path="/business/products/ar-virtual-accessories"
      component={AsyncPage}
  />,
];
